import { render } from "./CaricamentoVT4.vue?vue&type=template&id=0e39f55a&scoped=true"
import script from "./CaricamentoVT4.vue?vue&type=script&lang=js"
export * from "./CaricamentoVT4.vue?vue&type=script&lang=js"

import "./CaricamentoVT4.vue?vue&type=style&index=0&id=0e39f55a&scoped=true&lang=css"

import exportComponent from "/Users/giancotsu/Desktop/ASK/ask_file/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e39f55a"]])

export default __exports__